export default "Panorama des aides à la rénovation énergétique du patrimoine public : CEE collectivités, Fonds Vert, DETR/DSIL, Fonds Chaleur ADEME et Banque des Territoires. Cumuls et démarche.";
